import React from 'react';
import PropTypes from 'prop-types';

const Buttons = ({ button1, button2 }) => {
  if (!button1 && !button2) return null;
  return (
    <div className="max-w-md mx-auto mt-6 sm:flex sm:justify-center md:mt-12">
      <div className="rounded-md shadow">
        <a
          title={button1.title}
          target={/#/.test(button1.href) ? '_self' : '_blank'}
          rel="noreferrer"
          href={button1.href}
          className="flex items-center justify-center w-full px-8 py-3 text-base font-medium leading-6 text-indigo-700 transition duration-150 ease-in-out bg-gray-100 border border-transparent rounded-md hover:text-indigo-600 hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 focus:border-indigo-300 md:py-4 md:text-lg md:px-10"
        >
          {button1.text}
        </a>
      </div>
      <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
        <a
          href={button2.href}
          title={button2.title}
          rel="noreferrer"
          className="flex items-center justify-center w-full px-8 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 md:py-4 md:text-lg md:px-10"
        >
          {button2.text}
        </a>
      </div>
    </div>
  );
};

Buttons.defaultProps = {
  button1: null,
  button2: null,
};

Buttons.propTypes = {
  button1: PropTypes.shape({
    title: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  button2: PropTypes.shape({
    title: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
};

export default Buttons;
